import PropTypes from 'prop-types'
import { Redirect, Route, withRouter } from 'react-router-dom'

import { AuthLayout } from 'lmcv/containers/AuthLayout'

function PrivateRoute ({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        !localStorage.getItem('@loyalty:token')
          ? (<Redirect to="/faca-parte" />)
          : (
            <AuthLayout>
              <Component {...props} />
            </AuthLayout>
            )
      }
    />
  )
}

PrivateRoute.propTypes = {
  component: PropTypes.elementType
}

export default withRouter(PrivateRoute)
